namespace Areas.Attachment {
    "use strict";


    export function onValueChanged(e) {
        var newValue = e.value;
        if (newValue != e.previousValue) {
            var uploader = $("#fileUploaderControl").dxFileUploader("instance");
            var url = uploader.option("uploadUrl");
            url = updateQueryStringParameter(url, "fileDescription", newValue);
            console.log(url);
            uploader.option("uploadUrl", url);
        }
    }

    export function onUploadError(e) {
        DevExpress.ui.notify(e.error.responseText, "error", 2000);
    }

    export function addIconImage(cellElement, cellInfo) {
        var iconSource = cellInfo.data.icon;
        var img = "<img src='" + String(iconSource) + "'/>";
        cellElement.height(30);
        cellElement.html(img);
    }

    export function downloadAttachmentLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.attachmentId; },
            "<a href= '/File/Get/Attachment/{placeholder}'>Download</a>");
    }    

    export function refreshGridAfterUpload(e) {
        var uploadGrid = $("#attachmentDataGrid").dxDataGrid("instance");
        uploadGrid.refresh();
    }

    export function onCellPrepared(e) {

        if (e.rowType === "data" && e.column.command === "edit") {
            if (e.data.isReadOnly) {
                e.cellElement.empty();
            }
        }
    } 

 }                                                                      